import { Controller } from "@hotwired/stimulus"
import Alertify from "alertifyjs"

export default class extends Controller {
  static targets = ["fallback"]
  static values = { 
    notifications: { type: Array, default: [] },
    position: { type: String, default: "bottom-right" }
  }

  connect() {
    Alertify.set('notifier', 'position', this.positionValue)
    
    // Скрываем HTML fallback, так как JS работает
    this.hideFallback()
    
    this.showNotifications()
    
    // Listen for custom notification events
    this.boundHandleCustomNotification = this.handleCustomNotification.bind(this)
    document.addEventListener('show-notification', this.boundHandleCustomNotification)
  }
  
  disconnect() {
    document.removeEventListener('show-notification', this.boundHandleCustomNotification)
  }
  
  handleCustomNotification(event) {
    const { message, type } = event.detail
    this.addNotification(message, type)
  }

  hideFallback() {
    if (this.hasFallbackTarget) {
      this.fallbackTarget.style.display = 'none'
    }
  }

  getNotifications() {
    return JSON.parse(this.element.getAttribute("content"));
  }

  showNotifications() {
    const notifications = this.getNotifications();
    if (notifications && notifications.length > 0) {
      notifications.forEach((notification) => {
        // Map flash types to Alertify types
        let alertifyType = notification.type;
        if (notification.type === 'failure' || notification.type === 'alert') {
          alertifyType = 'error';
        } else if (notification.type === 'notice') {
          alertifyType = 'success';
        }
        
        Alertify.notify(notification.message, alertifyType)
      })

      this.clearNotifications()
    }
  }

  clearNotifications() {
    this.element.setAttribute("content", "[]");
  }

  addNotification(message, type = 'success') {
    // Map flash types to Alertify types
    let alertifyType = type;
    if (type === 'failure' || type === 'alert') {
      alertifyType = 'error';
    } else if (type === 'notice') {
      alertifyType = 'success';
    }
    
    Alertify.notify(message, alertifyType)
  }

  success(event) {
    const message = event.params.message || 'Success!'
    this.addNotification(message, 'success')
  }

  error(event) {
    const message = event.params.message || 'Error occurred!'
    this.addNotification(message, 'error')
  }

  warning(event) {
    const message = event.params.message || 'Warning!'
    this.addNotification(message, 'warning')
  }

  info(event) {
    const message = event.params.message || 'Info'
    this.addNotification(message, 'message')
  }

  failure(event) {
    const message = event.params.message || 'Operation failed!'
    this.addNotification(message, 'failure')
  }
}
